import React, { useEffect, useState } from "react";
import { Typography, Table, Tooltip } from "antd";
import MartLevelFilter from "./filter";
import moment from "moment";
import Pageloader from "../../../../components/loader";
import { dataKey } from "../../../../utils/Helpers";
import * as actionPage from "../../../../redux/actions/dashboard.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {InfoCircleOutlined} from "@ant-design/icons";
const { Title, Text } = Typography;

const pageName = "Mart Level View";

const MartLevel = (props) => {
  const [postData, setPostData] = useState(null);

  useEffect(() => {
    if (props?.pageFilter){
      postLists(props.pageFilter)
    }
  }, [props.pageFilter])

  const postLists = async(value) => {
    const {start_date, end_date} = value;
    if(start_date && end_date){
      const pageFilterData = {
        ...value,
        start_date: start_date.unix(),
        end_date: end_date.unix(),
        zoneIds: value?.zoneIds?.length === 0 ? undefined : await value?.zoneIds?.toString(),
      };
      const {date, ...rest} = pageFilterData
      rest?.zoneIds && await props.actionPage.LevelListAction(rest);
      // await props.actionPage.LevelListAction(rest);
    }
  }

  useEffect(() => {
    if (props?.pageData){setPostData(dataKey(props?.pageData))}
  }, [props?.pageData]);

  const columns = [
    {
      title: 'Zone Name',
      dataIndex: 'zone',
      render: (value) => ( `${value}` || "-" ),
      // sortDirections: ['ascend','descend','ascend'],
      sorter: {
        compare: (a, b) => a.zone.localeCompare(b.zone),
        multiple: 1,
      },
    },
    {
      title: ()=> <div>
        Planned Slots &nbsp;
        <Tooltip
            title="Sum of slots made available through bulk upload, single shift created later is excluded"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'planned_slots',
      render: (value) => (<Text>{value?.toFixed(2)}</Text> || "-"),
      // sortDirections: ['ascend','descend','ascend'],
      sorter: {
        compare: (a, b) => a.planned_slots - b.planned_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Scheduled Slots &nbsp;
        <Tooltip
            title="Sum of slots picked by rider, including bulk and single shifts"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'scheduled_slots',
      render: (value) => (<Text>{value?.toFixed(2)}</Text> || "-"),
      sorter: {
        compare: (a, b) => a.scheduled_slots - b.scheduled_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Overtime Shifts &nbsp;
        <Tooltip
            title="Sum of slots made available through single shift creation as extra shif"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'overtime_shifts',
      render: (value) => ( <Text>{value?.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.overtime_shifts - b.overtime_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Extra Shifts &nbsp;
        <Tooltip
            title="Sum of slots made available through single shift creation as extra shift"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'extra_shifts',
      render: (value) => ( <Text>{value?.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.extra_shifts - b.extra_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Special Hours Shift &nbsp;
        <Tooltip
          title="Sum of slots made available through single shift creation as special-hours shift"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'special_hours_shifts',
      render: (value) => ( <Text>{value?.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.special_hours_shifts - b.special_hours_shifts,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Active Slots &nbsp;
        <Tooltip
            title="Sum of Sum of slots (shifts) started by rider, including bulk and single shifts"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_slots',
      render: (value) => ( <Text>{value?.toFixed(2)}</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_slots - b.active_slots,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Fill Rate &nbsp;
        <Tooltip
            title="Formula: (Scheduled/Planned) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'fill_rate',
      render: (value) => ( <Text type={value > 85 ? "" : "danger"}>{value?.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.fill_rate - b.fill_rate,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Active vs Scheduled Rate &nbsp;
        <Tooltip
            title="Formula: (Active/Scheduled) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_vs_scheduled_rate',
      render: (value) => ( <Text>{value?.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_vs_scheduled_rate - b.active_vs_scheduled_rate,
        multiple: 1,
      },
    },
    {
      title:  ()=> <div>
        Active vs Planned Rate &nbsp;
        <Tooltip
            title="Formula: (Active/Planned) x 100"><InfoCircleOutlined/></Tooltip>
      </div>,
      dataIndex: 'active_vs_planned_rate',
      render: (value) => ( <Text>{value?.toFixed(2)}%</Text> || "-" ),
      sorter: {
        compare: (a, b) => a.active_vs_planned_rate - b.active_vs_planned_rate,
        multiple: 1,
      },
    },
  ]

  return (
    <div className="page-content">
        <div className="page-content-header">
            <Title level={2}>{pageName}</Title>
        </div>
        <MartLevelFilter />
        <div className="p-content">
          {props?.pageLoading ? <Pageloader /> :
            <Table dataSource={postData} columns={columns} pagination={false}/>
          }
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageData: state.DashboardReducer.shiftMartDashboardData,
    pageLoading: state.DashboardReducer.shiftDashboardLoader,
    pagePagination: state.DashboardReducer.shiftDashboardPaginationData,
    pageFilter: state.DashboardReducer.martDashboardFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MartLevel);